import _ from 'underscore';

import BasePaymentController from 'app/src/controllers/payments/BasePaymentController';
import Format from 'app/src/data/Format';
import Payment from 'app/src/data/models/Payment';
import Localize from 'app/src/localize/Localize';
import PaymentProvider from 'app/src/payments/PaymentProvider';
import PaymentTypeManager from 'app/src/payments/PaymentTypeManager';
import PaymentCreditDebitRefundView from 'app/src/views/payments/PaymentCreditDebitRefundView';

export default class PaymentCreditDebitRefundViewController extends BasePaymentController {
  constructor(saleManager, paymentProvider) {
    if (!(paymentProvider instanceof PaymentProvider)) {
      throw 'A payment provider must be provided.';
    }

    super(saleManager);

    this._paymentProvider = paymentProvider;

    // obtain the refundable payments
    const creditRefundablePayments = this._saleManager.refundablePaymentList.filter((payment) => {
      const paymentType = PaymentTypeManager.getPaymentTypeByAttributes({
        paymentTypeID: payment.paymentTypeID,
      });

      if (paymentType !== PaymentTypeManager.Types.TERMINAL) {
        return false;
      }

      if (
        payment.isServicePayment() &&
        payment.serviceModel.get('status') === Payment.Status.REFUNDED
      ) {
        return false;
      }

      return true;
    });

    // initialize the controller's managed view
    this.view = new PaymentCreditDebitRefundView({
      viewData: {
        currencySymbol: Localize.getCurrencySymbol(),
        creditDebitPayments: creditRefundablePayments.toJSON(),
        allowCredits: this._paymentProvider.activeGateway.allowNegativePayments,
        checkForDuplicateTransactions:
          this._paymentProvider.activeGateway.checkForDuplicateTransactions,
        outstandingBalance: this._saleManager.pendingBalance,
      },
    });
  }

  /**
   * Sets the initial state of dynamic data within the view
   */
  setInitialViewState() {
    if (this._paymentProvider.activeGatewaySupportsRefundByReference) {
      // Check to see if any of these payments have already been refunded;
      // if so, disable the Refund button for that payment
      _.each(this._saleManager._pendingPayments, (pendingPayment) => {
        const refPaymentID = pendingPayment.model.get('refPaymentID');

        if (refPaymentID) {
          this.view.disableRefundButton(refPaymentID);
        }
      });

      // need to check refunds that commit immediately as well
      this._saleManager.refundablePaymentList.forEach((payment) => {
        if (
          this._saleManager.creditDebitPayments.findWhere({
            refPaymentID: payment.model.id,
          })
        ) {
          this.view.disableRefundButton(payment.model.id);
        }
      });
    }
  }
}
